// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3cYUh","buttons":"SendReceipts_buttons__3ZJ39","email":"SendReceipts_email__3Zmhw","bookApptTitle":"SendReceipts_bookApptTitle__rVEdU"};